import React from 'react';
import type { CountdownParts } from '../hooks/useCountdown';
type CountdownBlockProps = {
  parts: CountdownParts;
  compact?: boolean;
};
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-54" data-mp="37u0of4ghkr0t">
      <span className="min-w-[3.25rem] rounded-2xl bg-bark-900 px-3 py-2.5 text-center font-display text-2xl font-semibold tabular-nums text-cream-100 sm:min-w-[4rem] sm:text-3xl" data-id="element-55" data-mp="37wv7osnrk5sn">
        {value}
      </span>
      <span className="mt-1.5 text-[0.65rem] font-bold uppercase tracking-[0.15em] text-bark-400" data-id="element-56" data-mp="2u3nbenoqmm4m">
        {label}
      </span>
    </div>;
}
export function CountdownBlock({
  parts,
  compact = false
}: CountdownBlockProps) {
  return <div role="timer" aria-live="off" aria-label={`Quedan ${parts.hours} horas, ${parts.minutes} minutos y ${parts.seconds} segundos`} className={['flex items-start justify-center gap-2 sm:gap-3', compact ? '' : 'mt-5'].join(' ')} data-id="element-57" data-mp="2k6ioumqzcona">
      <Unit value={parts.hours} label="Horas" data-id="element-58" data-mp="20wb59ujqvt8p" />
      <span aria-hidden="true" className="pt-2 font-display text-2xl text-bark-400 sm:text-3xl" data-id="element-59" data-mp="20vjecx13ejor">
        :
      </span>
      <Unit value={parts.minutes} label="Min" data-id="element-60" data-mp="25ocjhm0h3u1d" />
      <span aria-hidden="true" className="pt-2 font-display text-2xl text-bark-400 sm:text-3xl" data-id="element-61" data-mp="1qyn9d1aekfoy">
        :
      </span>
      <Unit value={parts.seconds} label="Seg" data-id="element-62" data-mp="1vy9m79mbjtx8" />
    </div>;
}